module.exports = __webpack_public_path__ + "website/img/imgth_l.fd73582f.png";